var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNo1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 285,
    height: 153,
    viewBox: "0 0 285 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4046 27.7308C26.7914 45.0207 27.8422 62.4558 31.5204 79.4268C35.1547 96.3165 41.2891 112.569 49.721 127.648C54.5021 136.159 60.0126 144.238 66.1905 151.796C67.699 153.651 70.3079 151.017 68.8118 149.175C47.3741 122.655 34.4873 90.2549 31.8543 56.2557C31.1247 46.7616 31.2115 37.2224 32.1139 27.7432C32.3488 25.3692 28.6395 25.3939 28.4046 27.7432V27.7308Z",
    fill: "#767676"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9657 15.8609C43.0569 12.7079 43.6751 12.8687 46.2964 8.13306C44.8126 12.4483 45.1341 19.7062 42.9579 23.7123C40.0894 29.0043 35.0447 33.4308 30.3091 33.4308C30.1972 30.0774 30.4626 26.7221 31.1004 23.4279C31.9164 20.275 37.703 18.1854 39.9657 15.8609Z",
    fill: "#767676"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9564 36.3983C38.7662 31.5762 46.0242 30.4386 50.9453 25.7401C49.6223 43.001 33.4248 49.6901 29.7154 49.5541C28.9983 49.5294 30.5685 39.7985 33.9564 36.3983Z",
    fill: "#767676"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6744 13.7218C24.7332 9.74043 24.0779 9.70333 23.0887 4.3866C23.0887 8.9491 20.5539 15.7372 21.3576 20.2255C22.4086 26.1481 25.8089 31.9347 30.3096 33.4308C31.4683 30.2822 32.2729 27.0143 32.7083 23.6876C32.9185 20.4357 28.0963 16.6275 26.6744 13.7218Z",
    fill: "#767676"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3809 49.1831C49.6714 45.6221 50.438 45.9189 54.3204 40.3177C51.9093 45.5479 51.3529 54.6729 48.1382 59.4209C43.8477 65.6032 36.9483 70.549 31.001 69.9431C31.3122 65.7498 32.0835 61.6034 33.3008 57.5786C34.6609 53.6591 42.228 51.792 45.3809 49.1831Z",
    fill: "#767676"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2973 50.395C9.71005 47.2296 8.95582 47.5882 4.60352 42.358C7.47208 47.3038 8.81981 56.3917 12.4797 60.8306C17.3019 66.679 24.5969 70.9448 30.47 69.8072C29.7968 65.6343 28.6605 61.5494 27.0822 57.6282C25.3017 53.9188 17.6481 52.7195 14.2973 50.395Z",
    fill: "#767676"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3816 86.524C56.9673 83.5442 57.6102 83.7915 60.8621 79.1053C58.8467 83.47 58.3892 91.1113 55.6566 95.0803C52.0709 100.298 46.2967 104.403 41.3262 103.884C41.5796 100.357 42.2265 96.8687 43.255 93.4853C44.4544 90.2705 50.7356 88.7126 53.3816 86.524Z",
    fill: "#767676"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8679 120.168C67.7241 117.794 68.2435 117.992 70.8276 114.258C69.2203 117.744 68.8493 123.828 66.6855 126.981C63.8293 131.147 59.2668 134.399 55.2607 133.991C55.4614 131.185 55.9756 128.411 56.7939 125.719C57.7584 123.123 62.766 121.874 64.8679 120.168Z",
    fill: "#767676"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8236 89.8995C15.0385 88.6631 14.5192 89.1824 9.28906 86.1902C13.1962 89.4791 17.0911 96.6135 21.4928 99.21C27.2918 102.61 34.6858 103.958 39.2359 101.213C37.4035 97.9358 35.214 94.8713 32.7074 92.0757C30.1356 89.4791 23.3846 90.8021 19.8236 89.8995Z",
    fill: "#767676"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4701 129.392C34.5135 129.392 34.2291 129.862 29.5801 128.539C33.2894 130.319 37.6541 135.079 41.5612 136.229C46.7172 137.738 52.6893 137.33 55.6939 134.325C53.6361 132.145 51.3429 130.2 48.8563 128.526C46.334 127.067 41.3634 129.404 38.4701 129.392Z",
    fill: "#767676"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8573 36.3983C20.0475 31.5762 12.8019 30.4386 7.88086 25.7401C9.20386 43.0504 25.3766 49.6531 29.0984 49.5541C29.8155 49.5294 28.2452 39.7985 24.8573 36.3983Z",
    fill: "#767676"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.324 73.6773C45.2698 68.7315 52.6886 67.4951 57.7456 62.7347C56.3855 80.4407 39.7924 87.2783 35.9717 87.167C35.2299 87.1546 36.8496 77.1517 40.324 73.6773Z",
    fill: "#767676"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6711 72.5273C18.3776 69.5104 10.9712 70.8952 4.60352 68.0266C11.7873 84.3107 29.7158 85.1762 33.2644 83.8037C33.9692 83.5441 29.11 74.654 24.6711 72.5273Z",
    fill: "#767676"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9332 110.276C54.927 106.282 60.9485 105.33 65.0288 101.436C63.9283 115.754 50.5005 121.281 47.4217 121.219C46.8159 121.145 48.1265 113.058 50.9332 110.276Z",
    fill: "#767676"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5792 111.29C31.8792 110.054 26.1545 112.687 20.4297 111.649C29.4681 123.358 44.1695 120.526 46.7784 118.709C47.2854 118.362 41.5853 112.131 37.5792 111.29Z",
    fill: "#767676"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M257.297 27.7307C260.425 61.672 253.214 95.7659 236.611 125.534C231.977 133.864 226.619 141.771 220.599 149.162C219.103 151.005 221.712 153.638 223.22 151.784C234.17 138.34 243.005 123.305 249.421 107.197C255.823 91.1474 259.795 74.232 261.204 57.0098C261.998 47.2632 261.931 37.4657 261.006 27.7307C260.771 25.3814 257.062 25.3567 257.297 27.7307Z",
    fill: "#767676"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M249.446 15.8609C246.355 12.7079 245.737 12.8687 243.115 8.13306C244.587 12.4483 244.278 19.7062 246.454 23.7123C249.322 29.0043 254.367 33.4308 259.103 33.4308C259.214 30.0774 258.949 26.7221 258.311 23.4279C257.495 20.275 251.709 18.1854 249.446 15.8609Z",
    fill: "#767676"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M255.454 36.3983C250.644 31.5762 243.386 30.4386 238.465 25.7401C239.788 43.001 255.985 49.6901 259.695 49.5541C260.412 49.5294 258.842 39.7985 255.454 36.3983Z",
    fill: "#767676"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M262.737 13.7218C264.678 9.74043 265.333 9.70333 266.31 4.3866C266.31 8.9491 268.857 15.7372 268.054 20.2255C267.003 26.1481 263.602 31.9347 259.102 33.4308C257.943 30.2822 257.138 27.0143 256.703 23.6876C256.493 20.4357 261.315 16.6275 262.737 13.7218Z",
    fill: "#767676"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M244.029 49.1831C239.739 45.6221 238.972 45.9189 235.09 40.3177C237.501 45.5479 238.057 54.6729 241.272 59.4209C245.563 65.6032 252.4 70.549 258.409 69.9431C258.098 65.7498 257.327 61.6034 256.11 57.5786C254.749 53.6591 247.17 51.792 244.029 49.1831Z",
    fill: "#767676"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M275.114 50.395C279.701 47.2296 280.456 47.5882 284.808 42.358C281.939 47.3038 280.592 56.3917 276.932 60.8306C272.11 66.679 264.815 70.9448 258.941 69.8072C259.615 65.6343 260.751 61.5494 262.329 57.6282C264.097 53.9188 271.763 52.7195 275.114 50.395Z",
    fill: "#767676"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M236.03 86.524C232.445 83.5442 231.789 83.7915 228.55 79.1053C230.565 83.47 231.023 91.1113 233.755 95.0803C237.341 100.298 243.115 104.403 248.086 103.884C247.832 100.357 247.185 96.8687 246.157 93.4853C244.945 90.2705 238.676 88.7126 236.03 86.524Z",
    fill: "#767676"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M224.543 120.168C221.687 117.794 221.167 117.992 218.583 114.258C220.19 117.744 220.561 123.828 222.725 126.981C225.581 131.147 230.144 134.399 234.15 133.991C233.949 131.185 233.435 128.411 232.617 125.719C231.652 123.123 226.645 121.874 224.543 120.168Z",
    fill: "#767676"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M269.587 89.8995C274.372 88.6631 274.891 89.1824 280.122 86.1902C276.214 89.4791 272.32 96.6135 267.918 99.21C262.119 102.61 254.725 103.958 250.175 101.213C252.003 97.9331 254.193 94.8682 256.703 92.0757C259.275 89.4791 266.026 90.8021 269.587 89.8995Z",
    fill: "#767676"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M250.942 129.392C254.898 129.392 255.183 129.862 259.832 128.539C256.122 130.319 251.758 135.079 247.85 136.229C242.694 137.738 236.722 137.33 233.718 134.325C235.776 132.145 238.069 130.2 240.555 128.526C243.078 127.067 248.048 129.404 250.942 129.392Z",
    fill: "#767676"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M264.554 36.3983C269.364 31.5762 276.609 30.4386 281.531 25.7401C280.208 43.0504 264.022 49.6531 260.313 49.5541C259.596 49.5294 261.166 39.7985 264.554 36.3983Z",
    fill: "#767676"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M249.087 73.6773C244.141 68.7315 236.722 67.4951 231.665 62.7347C233.025 80.4407 249.618 87.2783 253.439 87.167C254.181 87.1546 252.561 77.1517 249.087 73.6773Z",
    fill: "#767676"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M264.739 72.5273C271.033 69.5104 278.439 70.8952 284.807 68.0266C277.623 84.3107 259.695 85.1762 256.134 83.8037C255.441 83.5441 260.301 74.654 264.739 72.5273Z",
    fill: "#767676"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M238.478 110.276C234.485 106.282 228.463 105.33 224.383 101.436C225.483 115.754 238.911 121.281 241.99 121.219C242.596 121.145 241.285 113.058 238.478 110.276Z",
    fill: "#767676"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M251.831 111.29C257.531 110.054 263.256 112.687 268.981 111.649C259.943 123.358 245.241 120.526 242.632 118.709C242.125 118.362 247.825 112.131 251.831 111.29Z",
    fill: "#767676"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6966 24.0214C23.0834 41.3114 24.1342 58.7464 27.8124 75.7174C31.4467 92.6072 37.5811 108.86 46.013 123.939C50.7941 132.449 56.3046 140.529 62.4825 148.087C63.9909 149.942 66.5999 147.308 65.1037 145.466C43.6661 118.946 30.7793 86.5455 28.1463 52.5463C27.4167 43.0522 27.5035 33.513 28.4059 24.0338C28.6408 21.6598 24.9315 21.6845 24.6966 24.0338V24.0214Z",
    fill: "url(#paint0_linear_457_3816)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2577 12.1515C39.3489 8.99857 39.9671 9.15931 42.5884 4.42371C41.1046 8.73892 41.4261 15.9969 39.2499 20.003C36.3814 25.295 31.3367 29.7215 26.6011 29.7215C26.4892 26.3681 26.7546 23.0127 27.3924 19.7186C28.2084 16.5656 33.995 14.476 36.2577 12.1515Z",
    fill: "url(#paint1_linear_457_3816)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2474 32.689C35.0572 27.8668 42.3152 26.7293 47.2363 22.0308C45.9133 39.2916 29.7158 45.9808 26.0064 45.8448C25.2893 45.8201 26.8596 36.0892 30.2474 32.689Z",
    fill: "url(#paint2_linear_457_3816)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9654 10.0125C21.0242 6.03108 20.3689 5.99398 19.3797 0.677246C19.3797 5.23975 16.845 12.0279 17.6487 16.5162C18.6996 22.4388 22.0999 28.2254 26.6006 29.7215C27.7593 26.5728 28.5639 23.305 28.9993 19.9782C29.2095 16.7264 24.3873 12.9181 22.9654 10.0125Z",
    fill: "url(#paint3_linear_457_3816)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6729 45.4739C45.9634 41.9129 46.73 42.2096 50.6124 36.6085C48.2013 41.8387 47.6449 50.9637 44.4302 55.7117C40.1397 61.8939 33.2403 66.8397 27.293 66.2339C27.6042 62.0406 28.3755 57.8942 29.5927 53.8694C30.9528 49.9498 38.5199 48.0828 41.6729 45.4739Z",
    fill: "url(#paint4_linear_457_3816)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5883 46.6856C6.00107 43.5203 5.24684 43.8789 0.894531 38.6487C3.7631 43.5945 5.11082 52.6824 8.77071 57.1212C13.5929 62.9696 20.8879 67.2354 26.7611 66.0979C26.0878 61.9249 24.9515 57.84 23.3732 53.9188C21.5927 50.2095 13.9391 49.0101 10.5883 46.6856Z",
    fill: "url(#paint5_linear_457_3816)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6726 82.8147C53.2583 79.8349 53.9012 80.0821 57.1531 75.396C55.1377 79.7607 54.6802 87.4019 51.9476 91.371C48.3619 96.5888 42.5877 100.694 37.6172 100.174C37.8706 96.6472 38.5176 93.1594 39.546 89.7759C40.7454 86.5611 47.0266 85.0032 49.6726 82.8147Z",
    fill: "url(#paint6_linear_457_3816)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M61.158 116.458C64.0142 114.084 64.5335 114.282 67.1177 110.548C65.5103 114.035 65.1394 120.118 62.9756 123.271C60.1194 127.438 55.5569 130.69 51.5508 130.282C51.7514 127.476 52.2657 124.701 53.084 122.01C54.0484 119.413 59.056 118.165 61.158 116.458Z",
    fill: "url(#paint7_linear_457_3816)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1146 86.1902C11.3296 84.9537 10.8103 85.473 5.58008 82.4808C9.48726 85.7698 13.3821 92.9041 17.7838 95.5007C23.5828 98.9009 30.9768 100.249 35.5269 97.5037C33.6945 94.2264 31.505 91.162 28.9985 88.3663C26.4266 85.7698 19.6756 87.0928 16.1146 86.1902Z",
    fill: "url(#paint8_linear_457_3816)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7611 125.682C30.8045 125.682 30.5201 126.152 25.8711 124.829C29.5804 126.61 33.9451 131.37 37.8523 132.52C43.0083 134.029 48.9803 133.62 51.9849 130.616C49.9271 128.436 47.6339 126.491 45.1474 124.817C42.625 123.358 37.6544 125.695 34.7611 125.682Z",
    fill: "url(#paint9_linear_457_3816)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1474 32.689C16.3376 27.8668 9.09197 26.7293 4.1709 22.0308C5.4939 39.3411 21.6667 45.9437 25.3884 45.8448C26.1055 45.8201 24.5353 36.0892 21.1474 32.689Z",
    fill: "url(#paint10_linear_457_3816)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M36.616 69.968C41.5618 65.0222 48.9805 63.7857 54.0376 59.0254C52.6775 76.7314 36.0843 83.5689 32.2637 83.4576C31.5218 83.4453 33.1416 73.4424 36.616 69.968Z",
    fill: "url(#paint11_linear_457_3816)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9621 68.8181C14.6686 65.8011 7.26225 67.1859 0.894531 64.3174C8.07831 80.6014 26.0068 81.4669 29.5554 80.0945C30.2602 79.8348 25.401 70.9448 20.9621 68.8181Z",
    fill: "url(#paint12_linear_457_3816)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2243 106.567C51.218 102.573 57.2395 101.621 61.3198 97.7263C60.2193 112.044 46.7915 117.571 43.7127 117.51C43.1069 117.435 44.4175 109.349 47.2243 106.567Z",
    fill: "url(#paint13_linear_457_3816)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8703 107.581C28.1702 106.344 22.4455 108.978 16.7207 107.939C25.7592 119.649 40.4605 116.817 43.0695 115C43.5764 114.653 37.8764 108.422 33.8703 107.581Z",
    fill: "url(#paint14_linear_457_3816)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M253.588 24.0213C256.716 57.9627 249.505 92.0566 232.902 121.825C228.268 130.155 222.91 138.062 216.89 145.453C215.394 147.295 218.003 149.929 219.511 148.074C230.461 134.631 239.296 119.596 245.712 103.488C252.114 87.4381 256.086 70.5227 257.495 53.3005C258.289 43.5539 258.222 33.7563 257.297 24.0213C257.062 21.6721 253.353 21.6474 253.588 24.0213Z",
    fill: "url(#paint15_linear_457_3816)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M245.737 12.1515C242.646 8.99857 242.028 9.15931 239.406 4.42371C240.878 8.73892 240.569 15.9969 242.745 20.003C245.613 25.295 250.658 29.7215 255.394 29.7215C255.505 26.3681 255.24 23.0127 254.602 19.7186C253.786 16.5656 248 14.476 245.737 12.1515Z",
    fill: "url(#paint16_linear_457_3816)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M251.746 32.689C246.936 27.8668 239.678 26.7293 234.757 22.0308C236.08 39.2916 252.277 45.9808 255.987 45.8448C256.704 45.8201 255.134 36.0892 251.746 32.689Z",
    fill: "url(#paint17_linear_457_3816)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M259.028 10.0125C260.969 6.03108 261.624 5.99398 262.601 0.677246C262.601 5.23975 265.148 12.0279 264.345 16.5162C263.294 22.4388 259.893 28.2254 255.393 29.7215C254.234 26.5728 253.429 23.305 252.994 19.9782C252.784 16.7264 257.606 12.9181 259.028 10.0125Z",
    fill: "url(#paint18_linear_457_3816)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M240.32 45.4739C236.03 41.9129 235.263 42.2096 231.381 36.6085C233.792 41.8387 234.348 50.9637 237.563 55.7117C241.854 61.8939 248.691 66.8397 254.688 66.2339C254.386 62.0403 253.619 57.8934 252.401 53.8694C251.04 49.9498 243.461 48.0828 240.32 45.4739Z",
    fill: "url(#paint19_linear_457_3816)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M271.405 46.6856C275.992 43.5203 276.747 43.8789 281.099 38.6487C278.23 43.5945 276.883 52.6824 273.223 57.1212C268.401 62.9696 261.106 67.2354 255.232 66.0979C255.906 61.9249 257.042 57.84 258.62 53.9188C260.388 50.2095 268.054 49.0101 271.405 46.6856Z",
    fill: "url(#paint20_linear_457_3816)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M232.32 82.8147C228.735 79.8349 228.079 80.0821 224.84 75.396C226.855 79.7607 227.313 87.4019 230.045 91.371C233.631 96.5888 239.405 100.694 244.376 100.174C244.122 96.6472 243.475 93.1594 242.447 89.7759C241.235 86.5611 234.966 85.0032 232.32 82.8147Z",
    fill: "url(#paint21_linear_457_3816)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M220.835 116.458C217.978 114.084 217.459 114.282 214.875 110.548C216.482 114.035 216.853 120.118 219.017 123.271C221.873 127.438 226.436 130.69 230.442 130.282C230.241 127.476 229.727 124.701 228.909 122.01C227.944 119.413 222.937 118.165 220.835 116.458Z",
    fill: "url(#paint22_linear_457_3816)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M265.878 86.1902C270.663 84.9537 271.182 85.473 276.413 82.4808C272.505 85.7698 268.611 92.9041 264.209 95.5007C258.41 98.9009 251.016 100.249 246.466 97.5037C248.294 94.2237 250.484 91.1588 252.994 88.3663C255.566 85.7698 262.317 87.0928 265.878 86.1902Z",
    fill: "url(#paint23_linear_457_3816)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M247.232 125.682C251.188 125.682 251.473 126.152 256.122 124.829C252.412 126.61 248.048 131.37 244.14 132.52C238.984 134.029 233.012 133.62 230.008 130.616C232.066 128.436 234.359 126.491 236.845 124.817C239.368 123.358 244.338 125.695 247.232 125.682Z",
    fill: "url(#paint24_linear_457_3816)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M260.845 32.689C265.655 27.8668 272.9 26.7293 277.822 22.0308C276.499 39.3411 260.313 45.9437 256.604 45.8448C255.887 45.8201 257.457 36.0892 260.845 32.689Z",
    fill: "url(#paint25_linear_457_3816)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M245.379 69.968C240.433 65.0222 233.014 63.7857 227.957 59.0254C229.317 76.7314 245.91 83.5689 249.731 83.4576C250.473 83.4453 248.853 73.4424 245.379 69.968Z",
    fill: "url(#paint26_linear_457_3816)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M261.031 68.8181C267.325 65.8011 274.731 67.1859 281.099 64.3174C273.915 80.6014 255.987 81.4669 252.426 80.0945C251.733 79.8348 256.592 70.9448 261.031 68.8181Z",
    fill: "url(#paint27_linear_457_3816)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M234.768 106.567C230.775 102.573 224.753 101.621 220.673 97.7263C221.773 112.044 235.201 117.571 238.28 117.51C238.886 117.435 237.575 109.349 234.768 106.567Z",
    fill: "url(#paint28_linear_457_3816)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M248.122 107.581C253.822 106.344 259.547 108.978 265.272 107.939C256.234 119.649 241.532 116.817 238.923 115C238.416 114.653 244.116 108.422 248.122 107.581Z",
    fill: "url(#paint29_linear_457_3816)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_457_3816",
    x1: 44.7518,
    y1: 18.6429,
    x2: 44.7518,
    y2: 176.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECA937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4852C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_457_3816",
    x1: 34.5885,
    y1: 18.6429,
    x2: 34.5885,
    y2: 176.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECA937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4852C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_457_3816",
    x1: 36.541,
    y1: 18.6429,
    x2: 36.541,
    y2: 176.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECA937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4852C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_457_3816",
    x1: 23.2498,
    y1: 18.6429,
    x2: 23.2498,
    y2: 176.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECA937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4852C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_457_3816",
    x1: 38.9403,
    y1: 18.6429,
    x2: 38.9403,
    y2: 176.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECA937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4852C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_457_3816",
    x1: 13.8278,
    y1: 18.6429,
    x2: 13.8278,
    y2: 176.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECA937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4852C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_457_3816",
    x1: 47.3851,
    y1: 18.6429,
    x2: 47.3851,
    y2: 176.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECA937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4852C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_457_3816",
    x1: 59.3404,
    y1: 18.6428,
    x2: 59.3404,
    y2: 176.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECA937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4852C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_457_3816",
    x1: 20.603,
    y1: 18.6429,
    x2: 20.603,
    y2: 176.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECA937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4852C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_457_3816",
    x1: 38.928,
    y1: 18.6429,
    x2: 38.928,
    y2: 176.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECA937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4852C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_457_3816",
    x1: 14.8662,
    y1: 18.6429,
    x2: 14.8662,
    y2: 176.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECA937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4852C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_457_3816",
    x1: 43.0703,
    y1: 18.6429,
    x2: 43.0703,
    y2: 176.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECA937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4852C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_457_3816",
    x1: 15.2621,
    y1: 18.6429,
    x2: 15.2621,
    y2: 176.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECA937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4852C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_457_3816",
    x1: 52.4421,
    y1: 18.643,
    x2: 52.4421,
    y2: 176.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECA937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4852C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_457_3816",
    x1: 29.9013,
    y1: 18.643,
    x2: 29.9013,
    y2: 176.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECA937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4852C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_457_3816",
    x1: 237.242,
    y1: 18.6428,
    x2: 237.242,
    y2: 176.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECA937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4852C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_457_3816",
    x1: 247.406,
    y1: 18.6429,
    x2: 247.406,
    y2: 176.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECA937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4852C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_457_3816",
    x1: 245.452,
    y1: 18.6429,
    x2: 245.452,
    y2: 176.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECA937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4852C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_457_3816",
    x1: 258.743,
    y1: 18.6429,
    x2: 258.743,
    y2: 176.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECA937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4852C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_457_3816",
    x1: 243.053,
    y1: 18.6429,
    x2: 243.053,
    y2: 176.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECA937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4852C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_457_3816",
    x1: 268.166,
    y1: 18.6429,
    x2: 268.166,
    y2: 176.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECA937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4852C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_457_3816",
    x1: 234.608,
    y1: 18.6429,
    x2: 234.608,
    y2: 176.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECA937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4852C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_457_3816",
    x1: 222.652,
    y1: 18.6428,
    x2: 222.652,
    y2: 176.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECA937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4852C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_457_3816",
    x1: 261.39,
    y1: 18.6429,
    x2: 261.39,
    y2: 176.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECA937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4852C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_457_3816",
    x1: 243.065,
    y1: 18.6429,
    x2: 243.065,
    y2: 176.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECA937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4852C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_457_3816",
    x1: 267.126,
    y1: 18.6429,
    x2: 267.126,
    y2: 176.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECA937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4852C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_457_3816",
    x1: 238.924,
    y1: 18.6429,
    x2: 238.924,
    y2: 176.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECA937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4852C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_457_3816",
    x1: 266.731,
    y1: 18.6429,
    x2: 266.731,
    y2: 176.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECA937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4852C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_457_3816",
    x1: 229.551,
    y1: 18.643,
    x2: 229.551,
    y2: 176.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECA937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4852C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_457_3816",
    x1: 252.079,
    y1: 18.643,
    x2: 252.079,
    y2: 176.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECA937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4852C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo1);
export default __webpack_public_path__ + "static/media/no.1.aeab5479a9da9b3a45c70cf7d730a593.svg";
export { ForwardRef as ReactComponent };